// Category colors come from the API (backgroundColor/textColor/colorFill per
// category row) rather than being hardcoded by name, so new categories or
// palette changes on the backend show up automatically.

const FALLBACK_BACKGROUND = "#243746";
const FALLBACK_TEXT = "#fff";
const FALLBACK_UNSELECTED = "#adb7c0";

// Titles are not unique across branches (e.g. "Bundles" exists under several
// different top-level categories with different colors), so lookups must be
// scoped by parentCategoryId rather than title alone.
export function findCategoryRecord(apiCategories, title, parentId) {
  if (!Array.isArray(apiCategories)) return undefined;
  return apiCategories.find(
    (cat) => cat.title === title && (cat.parentCategoryId ?? null) === parentId
  );
}

// colorFill:true -> the category's own backgroundColor/textColor is its
// permanent look, shown whether selected or not (e.g. the always-visible
// top-level pills).
// colorFill:false/null -> the pill stays neutral gray until selected, then
// switches to its own backgroundColor/textColor.
export function getCategoryColorStyle(record, isSelected) {
  if (!record) {
    return isSelected
      ? { background: FALLBACK_BACKGROUND, color: FALLBACK_TEXT }
      : { background: FALLBACK_UNSELECTED, color: FALLBACK_TEXT };
  }

  if (record.colorFill || isSelected) {
    return {
      background: record.backgroundColor || FALLBACK_BACKGROUND,
      color: record.textColor || FALLBACK_TEXT,
    };
  }

  return { background: FALLBACK_UNSELECTED, color: FALLBACK_TEXT };
}
